var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isLoading
        ? _c("Spinner")
        : _vm.messagesClientError.message !== ""
        ? _c("Message", {
            attrs: {
              message: _vm.messagesClientError.message,
              icon: _vm.messagesClientError.icon,
            },
          })
        : _c(
            "div",
            [
              _c("div", { staticClass: "default-client-header" }, [
                _c("div", { staticClass: "header-name" }, [
                  _c(
                    "h2",
                    { staticClass: "title grand-size-text" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.client.name) +
                          " " +
                          _vm._s(_vm.client.lastName) +
                          " "
                      ),
                      _vm.client.defaultingCollectionUserId ===
                      _vm.currentUserId
                        ? _c(
                            "b-button",
                            {
                              staticClass:
                                "is-button-primary ml-2 is-small is-rounded is-pulled-right",
                              attrs: { id: "release-client" },
                              on: {
                                click: function ($event) {
                                  return _vm.returnToCollection(true)
                                },
                              },
                            },
                            [_vm._v(" Liberar ")]
                          )
                        : _c(
                            "b-button",
                            {
                              staticClass:
                                "is-button-primary ml-2 is-small is-rounded is-pulled-right",
                              attrs: { id: "release-client" },
                              on: {
                                click: function ($event) {
                                  return _vm.returnToCollection(false)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("backButton")) + " ")]
                          ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("div", { staticClass: "card-item client-info" }, [
                _c(
                  "div",
                  {
                    staticClass: "client-content-buttons",
                    attrs: { "data-cy": "client-content-buttons" },
                  },
                  [
                    _c(
                      "b-tabs",
                      {
                        attrs: { expanded: "", size: _vm.tabsSize },
                        model: {
                          value: _vm.selectedContent,
                          callback: function ($$v) {
                            _vm.selectedContent = $$v
                          },
                          expression: "selectedContent",
                        },
                      },
                      _vm._l(_vm.contentButtons, function (value, key) {
                        return _c("b-tab-item", {
                          key: key,
                          attrs: {
                            id: `${value}-data`,
                            label: value,
                            value: `${key}-data`,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm.selectedContent === "contact-data"
                  ? _c(
                      "div",
                      {
                        staticClass: "med-size-text",
                        attrs: { id: "client-contact-data" },
                      },
                      [
                        _c("div", { staticClass: "client-id-number" }, [
                          _c("span", { staticClass: "has-text-weight-bold" }, [
                            _vm._v(_vm._s(_vm.$t("dni"))),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.formatIdNumber(_vm.client.idNumber))
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "client-email" }, [
                          _c("span", { staticClass: "has-text-weight-bold" }, [
                            _vm._v("Email"),
                          ]),
                          _c("span", [_vm._v(_vm._s(_vm.client.email))]),
                        ]),
                        _c("div", { staticClass: "client-phone" }, [
                          _c("span", { staticClass: "has-text-weight-bold" }, [
                            _vm._v(_vm._s(_vm.$t("phone"))),
                          ]),
                          _vm.$i18n.locale === "pe"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatPhoneNumberPe(_vm.client.phone)
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm.$i18n.locale !== "pe"
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatPhoneNumber(_vm.client.phone)
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "client-id" }, [
                          _c("span", { staticClass: "has-text-weight-bold" }, [
                            _vm._v("Id cliente"),
                          ]),
                          _c("span", [_vm._v(_vm._s(_vm.client._id))]),
                        ]),
                        (_vm.client.availabilityInitialHour ||
                          _vm.client.availabilityEndHour) &&
                        _vm.$i18n.locale === "pe"
                          ? _c(
                              "div",
                              {
                                staticClass: "client-availability-initial-hour",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "has-text-weight-bold" },
                                  [_vm._v("Horario de visita")]
                                ),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.client.availabilityInitialHour ||
                                        "00:00"
                                    ) + " - "
                                  ),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.client.availabilityEndHour ||
                                          "23:59"
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm.client.address &&
                        (_vm.$i18n.locale === "br" || _vm.$i18n.locale === "pe")
                          ? _c("div", { staticClass: "client-id" }, [
                              _c(
                                "span",
                                { staticClass: "has-text-weight-bold" },
                                [_vm._v(_vm._s(_vm.$t("address")))]
                              ),
                              _c("span", [_vm._v(_vm._s(_vm.client.address))]),
                            ])
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm.selectedContent === "debt-data"
                  ? _c(
                      "div",
                      { attrs: { id: "client-debt-data" } },
                      [
                        _c("WalletBalance", {
                          attrs: { "client-balance": _vm.clientBalance },
                        }),
                        _vm.messagesDebtError.message !== ""
                          ? _c("Message", {
                              attrs: {
                                message: _vm.messagesDebtError.message,
                                icon: _vm.messagesDebtError.icon,
                              },
                            })
                          : _c(
                              "div",
                              [
                                _vm.relatedTransactions &&
                                _vm.relatedTransactions.length > 0
                                  ? _c("RelatedTransactions", {
                                      attrs: {
                                        "related-transactions":
                                          _vm.relatedTransactions,
                                        "payment-providers":
                                          _vm.paymentProviders,
                                        "cancel-related-transaction-button":
                                          "hide",
                                      },
                                      on: {
                                        "open-cancel-transaction-modal":
                                          _vm.openCancelTransactionModal,
                                      },
                                    })
                                  : _vm._e(),
                                _vm.creditList.length !== 0
                                  ? _c("ClientOperations", {
                                      attrs: {
                                        operations: _vm.creditList,
                                        "client-balance": _vm.clientBalance,
                                        "payments-map": _vm.paymentsMap,
                                        "collect-client-debt": true,
                                        "current-user-is-client":
                                          _vm.currentUserIsClient,
                                        "show-remove-late-charges":
                                          _vm.client
                                            .defaultingCollectionUserId ===
                                          _vm.currentUserId,
                                        "default-extend-payment-id":
                                          _vm.defaultExtendPaymentId,
                                      },
                                      on: {
                                        "remove-late-charges":
                                          _vm.removeLateCharges,
                                        "undo-remove-late-charges":
                                          _vm.undoRemoveLateCharges,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.selectedContent === "transaction-data"
                  ? _c(
                      "div",
                      { attrs: { id: "client-transaction-data" } },
                      [
                        _vm.messagesDebtError.message !== ""
                          ? _c("Message", {
                              attrs: {
                                message: _vm.messagesDebtError.message,
                                icon: _vm.messagesDebtError.icon,
                              },
                            })
                          : _c(
                              "div",
                              [
                                _c("router-view", {
                                  on: {
                                    "open-cancel-transaction-modal":
                                      _vm.openCancelTransactionModal,
                                  },
                                }),
                              ],
                              1
                            ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.selectedContent === "transactions-data"
                  ? _c(
                      "div",
                      { attrs: { id: "client-payments-data" } },
                      [
                        _c("TransactionsHistory", {
                          attrs: {
                            "current-user-is-client": _vm.currentUserIsClient,
                            "client-id": _vm.clientId,
                            "payment-providers": _vm.paymentProviders,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.selectedContent === "boletos-data"
                  ? _c(
                      "div",
                      { attrs: { id: "client-boletos-data" } },
                      [
                        _c("BoletosHistory", {
                          attrs: {
                            "current-user-is-client": _vm.currentUserIsClient,
                            "client-id": _vm.clientId,
                            "payment-providers": _vm.paymentProviders,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c("InteractionsHistory", {
                attrs: {
                  "managing-type": "SINGLE",
                  "loading-interactions": _vm.loadingInteractions,
                  interactions: _vm.clientDefaults,
                  "use-date-filters": true,
                  "date-constraints": _vm.dateConstraints,
                  "current-backoffice-related-user":
                    _vm.client.defaultingCollectionUser,
                  fields: _vm.interactionFields,
                },
                on: {
                  "update:loadingInteractions": function ($event) {
                    _vm.loadingInteractions = $event
                  },
                  "update:loading-interactions": function ($event) {
                    _vm.loadingInteractions = $event
                  },
                  "update:interactions": function ($event) {
                    _vm.clientDefaults = $event
                  },
                  "create-new-interaction": function ($event) {
                    return _vm.createNewInteraction($event)
                  },
                  "load-interactions": function ($event) {
                    return _vm.loadInteractions($event)
                  },
                },
              }),
            ],
            1
          ),
      _c(
        "b-modal",
        {
          attrs: { width: 600 },
          model: {
            value: _vm.cancellingRelatedTransaction.isModalActive,
            callback: function ($$v) {
              _vm.$set(_vm.cancellingRelatedTransaction, "isModalActive", $$v)
            },
            expression: "cancellingRelatedTransaction.isModalActive",
          },
        },
        [
          _c("div", { staticClass: "modal-card-body has-text-centered" }, [
            _c("div", { staticClass: "modal-card-header" }, [
              _c("div", { staticClass: "is-pulled-right" }, [
                _c(
                  "a",
                  {
                    staticClass: "close-modal",
                    on: {
                      click: function ($event) {
                        _vm.cancellingRelatedTransaction.isModalActive = false
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/ui/assets/img/plus-button.svg"),
                      },
                    }),
                  ]
                ),
              ]),
              _c("h3", { staticClass: "modal-title" }, [_vm._v("Anular Pago")]),
            ]),
            _c("section", { staticClass: "modal-card-body" }, [
              _c("p", [
                _vm._v(
                  ' Al hacer click en "Anular Pago", se descartará el pago creado y las cuotas volverán a estar disponibles para ser pagadas. Si realizaste una transacción, será necesario que vuelvas a hacer el proceso de pago para que sea validada. '
                ),
              ]),
              _c("div", { staticClass: "confirmation-buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-button-secondary is-rounded",
                    attrs: { id: "cancel-transaction-anulation" },
                    on: {
                      click: function ($event) {
                        _vm.cancellingRelatedTransaction.isModalActive = false
                      },
                    },
                  },
                  [_vm._v(" Volver ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "button is-button-primary is-rounded",
                    attrs: {
                      id: "anulate-transaction",
                      disabled:
                        _vm.cancellingRelatedTransaction.disabledCancelButton,
                    },
                    on: { click: _vm.cancelCurrentTransaction },
                  },
                  [_vm._v(" Anular Pago ")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }